import {makeStyles} from '@material-ui/core';

export const useCommonModalStyles = makeStyles(() => ({
    wrapper: {
        padding: '20px',
    },
    title: {
        fontFamily: 'LoraRegular',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '44px',
        lineHeight: '48.4px',
        color: '#456d69',
        marginBottom: '28px',
    },
    text: {fontFamily: 'FredokaLight', fontWeight: 400, fontSize: '18px', lineHeight: '28.8px', color: '#434343'},
    boldtext: {
        fontFamily: 'LoraSemiBold',
        fontWeight: 700,
        fontSize: '24px',
        lineHeight: '28.8px',
        color: '#434343',
        marginBottom: '38px',
    },
    boldBlueText: {
        fontFamily: 'FredokaSemiBold',
        fontSize: '24px',
        lineHeight: '38.4px',
        color: '#456d69',
        opacity: '90%',
    },
    ph: {
        marginTop: '32px',
        marginBottom: '36px',
        fontFamily: 'FredokaLight',
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '25.6px',
        color: '#3c3c3c',
        opacity: '90%',
    },
    navigation: {
        marginTop: '60px',
        display: 'flex',
        flexWrap: 'nowrap',
    },
    backBtn: {
        borderRadius: '20px',
        minWidth: '145px',
    },
    nextBtn: {
        width: '100%',
        borderRadius: '20px',
    },
    btnWrapper: {
        width: '100%',
        minWidth: '200px',
        maxWidth: '400px',
    },
    input: {
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(0, 0, 0, 0.87)',
            borderWidth: 1,
            borderRadius: 6,
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#E7E7E7',
            borderWidth: 1,
            borderRadius: 6,
        },

        '& .MuiOutlinedInput-input': {
            height: 50,
            boxSizing: 'border-box',
            fontFamily: 'FredokaRegular',
            fontSize: 17,
            lineHeight: '160%',
            color: '#5D807B',
            padding: '12px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            '& ::placeholder': {
                color: '#5D807B',
            },
        },
    },
    select: {
        '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#E7E7E7',
            borderWidth: 1,
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#E7E7E7',
            borderRadius: 6,
        },
        '& .MuiSelect-select:focus': {
            backgroundColor: 'transparent',
        },
        '& .MuiSelect-select': {
            display: 'flex',
            alignItems: 'center',
            height: '100%',
            boxSizing: 'border-box',
            padding: '12px',
        },

        height: 50,
        fontFamily: 'FredokaRegular',
        fontSize: 17,
        lineHeight: '160%',
        color: '#5D807B',

        '& ::placeholder': {
            color: '#5D807B',
        },
    },
    arrowBtn: {
        borderRadius: '50%',
        width: 64,
        height: 64,
        border: '2px solid #174943',
        color: '#174943',
        padding: 0,
        transition: 'background-color 0.2s',
        '&:hover': {
            color: '#4fc878',
            borderColor: 'transparent',
            backgroundColor: '#174943',
        },
        '&.Mui-focusVisible': {
            color: '#4fc878',
            borderColor: 'transparent',
            backgroundColor: '#174943',
        },
        '&.Mui-disabled': {
            color: '#00000042',
            borderColor: 'transparent',
            backgroundColor: '#0000001f',
        },
        '& .MuiSvgIcon-root': {
            width: 28,
            height: 28,
        },
    },
    outlinedBtn: {
        minWidth: '240px',
        minHeight: '64px',
        border: '2px solid #5ae288',
        fontFamily: 'FredokaRegular',
        fontSize: '18px',
        letterSpacing: '0.05em',
        color: '#174943',
        padding: '12px 40px',
        backgroundColor: '#5ae288',
        borderRadius: 102,
        boxSizing: 'border-box',
        transition: 'background-color 0.2s',
        '&:hover': {
            color: '#174943',
            borderColor: 'transparent',
            backgroundColor: '#9cedb7',
        },
        '&.Mui-focusVisible': {
            color: '#174943',
            borderColor: 'transparent',
            backgroundColor: '#9cedb7',
        },
        '&.Mui-disabled': {
            color: '#00000042',
            borderColor: 'transparent',
            backgroundColor: '#0000001f',
        },
    },
    nav: {
        bottom: 0,
        left: 0,
        right: 0,
        marginTop: 0,
        padding: '16px 20px',
        backgroundColor: '#fff',
        marginLeft: '16.666%',
        width: 'calc(100% - 16.666%)',
        boxShadow: '6px -4px 10px rgba(0, 0, 0, 0.08)',
        zIndex: 10,
        height: '100px',
        position: 'fixed',
        justifyContent: 'center',
    },
    stickyNav: {
        width: 'calc(100% + 16px)',
        margin: '-8px',
        backgroundColor: '#fff',
        justifyContent: 'flex-start',
        top: -8,
        paddingTop: 20,
        paddingBottom: 20,
        position: 'sticky',
        zIndex: 100,
    },
    stickyBorder: {
        borderBottom: '1px solid #D1DBD9',
    },
    navContent: {
        display: 'flex',
        width: 'fit-content',
        alignItems: 'center',
        gap: 16,
    },
    label: {
        fontFamily: 'FredokaMedium',
        fontWeight: 500,
        fontSize: '18px',
        lineHeight: '160%',
        color: '#838383',
        marginBottom: 6,
    },
    autocomplete: {
        '& .MuiAutocomplete-inputRoot': {
            height: '100%',
            padding: 0,
            '& .MuiAutocomplete-input:first-child': {
                padding: '12px',
            },
        },
        height: 50,
        fontFamily: 'FredokaRegular',
        fontSize: 17,
        lineHeight: '160%',
        color: '#5D807B',
        '& ::placeholder': {
            color: '#5D807B',
        },
    },
}));
